import { makeAutoObservable } from 'mobx'

import { MONDU_KEY } from 'constants/options.constants'

import { ShopRootStore } from 'shop/stores/shopRoot.store'
import {
  CURRENCY_COUNTRY_MAP,
  MONDU_COUNTRIES,
  PAYER_FORM_TYPE,
  STIPE_ELEMENT_OPTIONS_DEFAULT,
} from 'constants/paymentSettingShared.constants'
import type { StripeElementsOptionsMode } from '@stripe/stripe-js'
import { PAYMENT_PLANS } from 'constants/pricingPlans.constants'
import {
  StripeElementOptions,
  StripeElementsPayloads,
  StripePaymentMethod,
  StripePaymentMethodShop,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopMonduPaymentMethodStore implements StripePaymentMethod, StripePaymentMethodShop, StripeElementOptions {
  storeName = 'shopMonduPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  isAppActive() {
    return this.root.sellerStore.isAppActive(MONDU_KEY)
  }

  isEnabled() {
    return this.root.sellerStore.item?.monduEnabled
  }

  isAvailable = (activeCountry: string, currency: string): boolean =>
    this.isAppActive() &&
    MONDU_COUNTRIES.includes((activeCountry || 'DE').toUpperCase()) &&
    CURRENCY_COUNTRY_MAP[currency.toUpperCase()]?.includes(activeCountry)

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    let store: StripeElementsPayloads = null
    if (isDealsPage) {
      store = this.root.dealsStore
    } else if (isManagePage) {
      store = this.root.ordersStore
    } else {
      store = this.root.paymentStore
    }

    return (
      (store?.getMonduStripeElementPayload && store.getMonduStripeElementPayload()) || STIPE_ELEMENT_OPTIONS_DEFAULT
    )
  }

  isAvailableForPayerType = () => {
    const privateTypes = [PAYER_FORM_TYPE.private, PAYER_FORM_TYPE.private250]

    const formTypeFromPayment = this.root.paymentStore.payerForms?.formType
    const formTypeFromOrder = this.root.ordersStore.data?.payerData?.formType

    return !privateTypes.includes(formTypeFromPayment) && !privateTypes.includes(formTypeFromOrder)
  }

  isAvailableForPricingPlan = ({ withTestPeriod, withCustomStart, pricingPlanForm }) =>
    !withTestPeriod && !withCustomStart && pricingPlanForm === PAYMENT_PLANS.oneTime

  getPaymentElementOptions = () => {}
}
